module.exports = __webpack_public_path__ + "static/media/ocd_thumb.fcd0c4df.webp";